import type { CollectibleItem } from "../types/game";

export const collectibleItems: CollectibleItem[] = [
  {
    id: "item_001",
    name: "Family Holiday",
    cost: 30,
    resaleValue: 0,
    description: "A trip together refreshes everyone.",
    wlbBonus: 4,
    emoji: "✈️",
    bestseller: true,
  },
  {
    id: "item_002",
    name: "Bicycle",
    cost: 20,
    resaleValue: 10,
    description: "Get fit and save on transport.",
    wlbBonus: 2,
    emoji: "🚲",
  },
  {
    id: "item_003",
    name: "Gaming Console",
    cost: 35,
    resaleValue: 15,
    description: "Fun for the whole family.",
    wlbBonus: 3,
    emoji: "🎮",
  },
  {
    id: "item_004",
    name: "Reliable Car",
    cost: 50,
    resaleValue: 30,
    description: "Opens up better jobs and saves commute stress.",
    wlbBonus: 4,
    emoji: "🚗",
    bestseller: true,
  },
  {
    id: "item_005",
    name: "Garden Shed",
    cost: 25,
    resaleValue: 20,
    description: "A weekend project that adds home value.",
    wlbBonus: 2,
    emoji: "🏡",
  },
  {
    id: "item_006",
    name: "Music Lessons",
    cost: 15,
    resaleValue: 0,
    description: "A creative outlet that reduces stress.",
    wlbBonus: 3,
    emoji: "🎵",
    bestseller: true,
  },
  {
    id: "item_007",
    name: "Emergency Fund Jar",
    cost: 40,
    resaleValue: 40,
    description: "Locked savings — protected from events.",
    wlbBonus: 2,
    emoji: "🏦",
  },
  {
    id: "item_008",
    name: "Fitness Equipment",
    cost: 20,
    resaleValue: 8,
    description: "Exercise improves focus and mood.",
    wlbBonus: 2,
    emoji: "🏋️",
  },
];
